import '../scss/compose-pack.scss';
import { $Q, $Qll } from '../utils/query-selector';
import Swiper, { Navigation, Manipulation } from 'swiper';
import api from '../services/api';
import { composerPopup } from '../components/composer-popup';

const isSwiperUsage = window.innerWidth >= 1024;
let composeSwiper = {};

// init Slider
if (isSwiperUsage) {
  composeSwiper = new Swiper('.compose-swiper', {
    modules: [Navigation, Manipulation],
    slidesPerView: 'auto',
    spaceBetween: 8,
    navigation: {
      nextEl: `.swiper-button-next[data-id="slider_compose"]`,
      prevEl: `.swiper-button-prev[data-id="slider_compose"]`,
    },
  });
}

/**
 * Toggle add to cart buttons (Disabled, Active)
 * @param {boolean} isDisable Represent state of disable
 */
const toggleCartButtons = (isDisable) => {
  $Q('#compose-add-cart').disabled = isDisable;
  $Q('#compose-add-other').disabled = isDisable;
};

/**
 * Action for add item in composition pack
 * @param {Element} productInput DOM element with input product card
 */
// eslint-disable-next-line complexity
const plusAction = (productInput) => {
  try {
    const priceLabel = $Q('.compose-information__pricing .price');
    const bottlesLabel = $Q('.compose-information__pricing .quantity .current');
    const bottleArray = bottlesLabel.innerHTML
      .split('/')
      .map((item) => Number(item));
    if (bottleArray[0] < bottleArray[1]) {
      const newBottleQuantity = bottleArray[0] + 1;
      $Qll('.compose-information__pricing .quantity .current').forEach(
        (label) => {
          // eslint-disable-next-line no-param-reassign
          label.innerHTML = `${newBottleQuantity}/${bottleArray[1]}`;
        },
      );

      if (productInput.dataset.priceprice !== '') {
        const addPrice = Number(productInput.dataset.price) * 100;

        const newPrice = Number(priceLabel.dataset.price) + addPrice;
        const newPriceFormatted = (newPrice / 100).toFixed(2).replace('.', ',');
        $Qll('.compose-information__pricing .price').forEach((label) => {
          // eslint-disable-next-line no-param-reassign
          label.dataset.price = newPrice;

          // eslint-disable-next-line no-param-reassign
          label.innerHTML = `${newPriceFormatted}€`;
        });
      }

      const card = $Q(`.product-card[data-product-id="${productInput.dataset.id}"]`)
      if (card) {
        const labelAdded = $Q('.item-quantity__added', card)
        if (labelAdded.classList.contains('hidden')) {
          labelAdded.classList.remove('hidden')
          labelAdded.classList.remove('loading')

          labelAdded.innerHTML = labelAdded.dataset.text;
        }
      }

      toggleCartButtons(newBottleQuantity !== bottleArray[1]);
      return true;
    }
  } catch (error) {
    console.log(error);
  }
  return false;
};

/**
 * Action for remove item in composition pack
 * @param {Element} productInput DOM element with input product card
 */
// eslint-disable-next-line complexity
const subtrAction = (productInput) => {
  if (Number(productInput.value) - 1 >= 0) {
    try {
      const priceLabel = $Q('.compose-information__pricing .price');
      const bottlesLabel = $Q(
        '.compose-information__pricing .quantity .current',
      );
      const bottleArray = bottlesLabel.innerHTML
        .split('/')
        .map((item) => Number(item));

      if (bottleArray[0] > 0 && bottleArray[0] <= bottleArray[1]) {
        const newBottleQuantity = bottleArray[0] - 1;
        $Qll('.compose-information__pricing .quantity .current').forEach(
          (label) => {
            // eslint-disable-next-line no-param-reassign
            label.innerHTML = `${newBottleQuantity}/${bottleArray[1]}`;
          },
        );

        if (productInput.dataset.priceprice !== '') {
          const addPrice = Number(productInput.dataset.price) * 100;

          const newPrice = Number(priceLabel.dataset.price) - addPrice;
          const newPriceFormatted = (newPrice / 100).toFixed(2).replace('.', ',')
          $Qll('.compose-information__pricing .price').forEach((label) => {
            priceLabel.dataset.price = newPrice;

            // eslint-disable-next-line no-param-reassign
            label.innerHTML = `${newPriceFormatted}€`;
          });
        }

        const card = $Q(`.product-card[data-product-id="${productInput.dataset.id}"]`)
        if ((Number(productInput.value) - 1) === 0 && card) {
          const labelAdded = $Q('.item-quantity__added', card)
          if (!labelAdded.classList.contains('hidden')) {
            labelAdded.classList.add('hidden')
          }
        }

        toggleCartButtons(newBottleQuantity !== bottleArray[1]);
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  return false;
};

/**
 *
 * @param {Boolean} active Represent state of active
 * @param {string} id product card Id
 */
const toggleQuantity = (active, id) => {
  const quantity = $Q(`#item-quantity--${id}`);
  const button = $Q(`#product-card-btn--${id}`);
  if (active) {
    quantity.classList.remove('hidden');
    button.classList.add('hidden');
  } else {
    quantity.classList.add('hidden');
    button.classList.remove('hidden');
  }
};

/**
 * Add new product to compose swiper
 * @param {Element} dataset Input DOM element
 */
const addSlide = (productInput) => {
  const { name, img, id } = productInput.dataset;
  const index = Math.random().toString(16).slice(2);
  const itemContent = document.createElement('div');
  itemContent.setAttribute("class", "swiper-slide compose-slide");
  itemContent.setAttribute("id", `slide-${id}-${index}`);
  itemContent.setAttribute("data-id", `${id}`);
  itemContent.innerHTML = `
    <img
      src="${img}"
      alt="${name}"
      width="60"
      height="60"
      loading="lazy"
      class="item-image"/>
    <span class="par-regular par-regular--m">
      ${name.length < 25 ? name : `${name.slice(0, 25)}...`}
    </span>
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4.33268 2.33335V0.666687H12.666V2.33335H16.8327V4.00002H15.166V16.5C15.166 16.721 15.0782 16.933 14.9219 17.0893C14.7657 17.2456 14.5537 17.3334 14.3327 17.3334H2.66602C2.445 17.3334 2.23304 17.2456 2.07676 17.0893C1.92048 16.933 1.83268 16.721 1.83268 16.5V4.00002H0.166016V2.33335H4.33268ZM3.49935 4.00002V15.6667H13.4993V4.00002H3.49935ZM5.99935 6.50002H7.66602V13.1667H5.99935V6.50002ZM9.33268 6.50002H10.9993V13.1667H9.33268V6.50002Z" fill="#A3ADBB" />
    </svg>`;

  if (isSwiperUsage) {
    composeSwiper.appendSlide(itemContent);

    const currentSlides = composeSwiper.slides
    composeSwiper.slideTo(currentSlides.length - 1, 0.2);
  } else {
    $Q('.compose-information__items .swiper-wrapper').appendChild(itemContent);
  }

  $Q(`#slide-${id}-${index}`).addEventListener('click', () => {
    productInput.dispatchEvent(
      new CustomEvent('updateComposePack', {
        bubbles: true,
        detail: { action: 'subtr', dataIndex: `slide-${id}-${index}` },
      }),
    );
  });
};

/**
 * Delete product to compose swiper
 * @param {Object} dataset Input dataset
 */
const removeSlide = (dataIndex) => {
  if (isSwiperUsage) {
    for (const [index, slide] of composeSwiper.slides.entries()) {
      if (slide.id === dataIndex) {
        composeSwiper.removeSlide(index);
        break;
      }
    }
  } else {
    const composeContainer = $Q('.compose-information__items .swiper-wrapper');
    const lstSlides = $Qll('.compose-information__items .compose-slide');
    const slide = lstSlides.find((slide) => slide.id === dataIndex);

    if (slide) composeContainer.removeChild(slide);
  }
};

/**
 * Reset compose pack properties
 */
const resetComposePack = () => {
  $Qll('.compose-information__pricing .price').forEach((item) => {
    const priceBase = parseFloat(item.dataset.base) / 100;
    item.innerHTML = `${priceBase.toFixed(2).replace('.', ',')}€`;
    item.dataset.price = item.dataset.base;
  });

  $Qll('.compose-information__pricing .quantity .current').forEach((item) => {
    const quantityList = item.innerHTML.split('/');
    item.innerHTML = `0/${quantityList[1]}`;
  });

  isSwiperUsage
    ? composeSwiper.removeAllSlides()
    : ($Q('.compose-information__items .swiper-wrapper').innerHTML = '');

  $Qll('.quantity-label-compose .input-quantity').forEach((quantity) => {
    if (quantity.value > 0) {
      toggleQuantity(false, quantity.dataset.id);
      quantity.value = 0;
    }
  });

  toggleCartButtons(true);
};

/**
 * Create array with pack items
 * @returns Array of objects
 */
const buildPackArray = () => {
  const itemsList = $Qll('.quantity-label-compose .input-quantity').filter(
    (item) => Number(item.value) > 0
  );

  return itemsList.map((item) => ({
    name: item.dataset.name,
    image: item.dataset.img,
    handle: item.dataset.handle,
    quantity: Number(item.value),
    additionalPrice: parseFloat(item.dataset.price) || 0,
  }));
};

/**
 * Get variant that add to cart
 * @param {Number} additionalPrice
 * @returns Variant
 */
const getVariantProduct = async (additionalPrice) => {
  try {
    const productHandle = $Q('.compose-information').dataset.product;
    const product = await api.getProductByHandle(productHandle);
    const packPrice = product.variants[0].price + additionalPrice;

    for (const variant of product.variants) {
      if (packPrice === variant.price) {
        return variant;
      }
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * Add cart action
 */
const addCartAction = async () => {
  const form = $Q('.compose-information__actions');
  const listPack = buildPackArray();
  const variant = await getVariantProduct(
    listPack.reduce(
      (total, item) => total + item.additionalPrice * item.quantity * 100,
      0
    )
  );
  if (variant) {
    const properties = {};
    listPack.forEach((item) => {
      properties[item.name] = `${item.handle} x ${item.quantity}`;
    });

    $Q(`input[name="id"]`, form).value = variant.id;
    $Q(`input[name="properties"]`, form).value = JSON.stringify(properties);

    const fakeButton = document.createElement('button');
    fakeButton.style.display = 'none';
    form.appendChild(fakeButton);
    fakeButton.click();
    fakeButton.remove();
  }
};

/**
 * Init Events
 */
toggleCartButtons(true);

/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
window.addEventListener('load', () => {
  $Qll('.quantity-label-compose button').forEach((item) => {
    item.addEventListener('click', (e) => {
      const parent = e.currentTarget.parentNode;
      const input = $Q('input', parent);

      const detail = { action: item.dataset.action }

      const productid = input.dataset.id;
      const slides = document.querySelectorAll(`.compose-swiper .swiper-slide[data-id="${productid}"]`)
      if (slides.length > 0) {
        const lastslide = [...slides][[...slides].length - 1].getAttribute('id');
        detail.dataIndex = lastslide
      }

      input.dispatchEvent(
        new CustomEvent('updateComposePack', {
          bubbles: true,
          detail,
        }),
      );
    });
  });

  $Qll('.product-card').forEach((item) => {
    const input = $Q('.input-quantity', item);
    const button = $Q('.compose-product', item);
    if (input && button) {
      button.addEventListener('click', () => {
        input.dispatchEvent(
          new CustomEvent('updateComposePack', {
            bubbles: true,
            detail: { action: 'plus' },
          })
        );
      });
    }
  });

  $Qll('.quantity-label-compose .input-quantity').forEach((quantity) => {
    quantity.addEventListener(
      'updateComposePack',
      ({ currentTarget, detail }) => {
        const input = currentTarget;
        let valid = false;

        switch (detail.action) {
          case 'plus':
            valid = plusAction(input);
            if (valid) {
              input.value++;
              addSlide(input);
            }
            break;
          case 'subtr':
            valid = subtrAction(input);
            if (valid) {
              input.value--;
              removeSlide(detail.dataIndex);
            }
            break;
          default:
            break;
        }

        toggleQuantity(input.value > 0, input.dataset.id);
      }
    );
  });

  $Q('#compose-add-cart').addEventListener('click', async () => {
    $Q('.compose-information__actions').removeAttribute('data-not-open-cart');
    await addCartAction();
    resetComposePack();
  });

  $Q('#compose-add-other').addEventListener('click', async () => {
    $Q('.compose-information__actions').setAttribute('data-not-open-cart', '');
    await addCartAction();
    resetComposePack();
  });

  $Q('.toggle-list').addEventListener('click', (e) => {
    e.currentTarget.classList.toggle('active');
    $Q('.compose-information .compose-information__pricing').classList.toggle('active');
    $Q('.compose-swiper .swiper-wrapper').classList.toggle('active');
  });
});

composerPopup('.main-collection__products');
